import styled from "styled-components";
import { Input, Table, Modal, Select } from "antd";
import {
  DataValue,
  DataHeading,
  GhostButtonComponent,
  PrimaryButtonComponent,
  UnderlineLink,
  CommonTable
} from "../../../../../CommonComponents/commonStyles";

export const Title = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.headingColor};
  line-height: ${props => props.theme.lineHeight.h4};
  font-weight: ${props => props.theme.fontWeight.w500};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media (max-width: 576px) {
    line-height: ${props => props.theme.lineHeight.h5};
    font-size: ${props => props.theme.fontSize.h5};
  }
`;

export const RadioWrapper = styled.div`
  &&& {
    div .ant-radio-wrapper {
      display: block;
      margin-top: 10px;
    }
    label {
      font-family: ${props => props.theme.fontFamily.HelveticaNeue};
      font-size: ${props => props.theme.fontSize.primary};
      color: ${props => props.theme.fontColors.thead};
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  border-bottom: none;
  border-bottom: solid 1px ${props => props.theme.border.pill};
  margin: 50px 0;
  @media (max-width: 576px) {
    margin: 40px 0;
  }
`;

export const Description = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.thead};
  line-height: ${props => props.theme.lineHeight.primary};
  margin: 15px 0 30px 0;
  @media (max-width: 576px) {
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary};
    margin: 5px 0 20px 0;
  }
`;

export const HeighlightedContent = styled.p`
  font-family: ${props => props.theme.fontFamily.HelveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.heading};
  }
`;

export const DescriptionSpan = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  line-height: ${props => props.theme.lineHeight.primary};
  margin-left: 10px;
  @media (max-width: 576px) {
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary};
    margin-left: 0px;
  }
`;

export const InputBox = styled(Input)`
  width: 197px;
  height: 30px;
  margin: 0 20px;
  &&& {
    input {
      padding-left: 20px;
    }
    .ant-input-group-addon {
      background-color: transparent;
      border: none;
      padding: 0px;
      left: 17px;
      position: relative;
      z-index: 8;
    }
  }
  @media only screen and (max-width: 576px) {
    margin: 5px 0 10px -10px;
  }
`;

export const CurrencyDiv = styled.div`

  margin: 0 20px 0 30px;
  @media(max-width: 576px){
    margin: 10px 0 20px 0;
  }
`;

export const FlexCenterWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 767.92px) {
    display: block;
    margin-top: 20px;
    &&& > span {
      display: block;
    }
  }
`;

export const ExchangeFromTable = styled(CommonTable)`
  .ant-table-footer {
    background-color: ${props => props.theme.backgroundColor.layoutLight};
    padding: 20px 23px 20px 16px;
    border-top: solid 2px ${props => props.theme.border.primary};
    border-radius: 0px;
  };
  .ant-table-row:nth-child(2n+1) {
    background-color: ${props => props.theme.backgroundColor.tabBackground} ;
  }
`;

export const ExchangeToTable = styled(CommonTable)`
  &&& {
    .ant-table-row:nth-child(2n+1) {
      background-color: ${props => props.theme.backgroundColor.tabBackground} ;
    }
    .ant-table .ant-table-header colgroup col:first-child,
    .ant-table .ant-table-body colgroup col:first-child {
      display: none;
    }
    .ant-table-thead > tr:first-child > th:first-child {
      display: none;
    }
    :last-child{
      border-bottom: 1px solid ${props => props.theme.border.primary};
      border-radius: 0px;
    }
  }
  .ant-table .ant-table-tbody .ant-table-row:nth-child(1) {
    height: 5rem;
    td:first-child {
      font-family: ${props => props.theme.fontFamily.berkeleyStd} !important;
      font-size: ${props => props.theme.fontSize.h4} !important;
      letter-spacing: ${props => props.theme.letterSpacing.normal} !important;
      color: ${props => props.theme.fontColors.headingColor} !important;
      text-transform: capitalize !important;
      line-height: ${props => props.theme.lineHeight.h5} !important;
      background-color: ${props => props.theme.backgroundColor.layoutLight};
      padding: 30px 16px !important;
      @media only screen and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.heading} !important;
      }
    }
    td:not(:first-child) {
      display: none;
    }
    td:last-child {
      display: none;
    }
  }
  .ant-table-footer {
    border-radius: 0px;
    background-color: ${props => props.theme.backgroundColor.layoutLight};
    padding: 30px 16px 30px 16px;
    align-items: center;
    > div {
      width: 100%;
    }
  }
`;

export const TableInputBox = styled.input`
  border: solid 1px ${props => props.theme.border.filledTabsInactive};
  height: 40px;
  width: 100px;
  padding-left: 20px;
  float: right;
  &:focus {
    border: 1px solid ${props => props.theme.border.inputBox};
    outline-color: ${props => props.theme.border.inputBox};
    outline-width: 1px;
  }
  @media only screen and (min-width: 1025px) {
    margin-right: 14px;
  }
  @media only screen and (max-width: 990px) {
    width: 100%;
    padding-left: 10px;
  }
`;

export const TableInputBoxInto = styled.input`
  border: solid 1px ${props => props.theme.border.filledTabsInactive};
  height: 40px;
  width: 150px;
  padding-left: 20px;
  float: right;
  &:focus {
    border: 1px solid ${props => props.theme.border.inputBox};
    outline-color: ${props => props.theme.border.inputBox};
    outline-width: 1px;
  }
  @media only screen and (min-width: 1025px) {
    margin-right: 14px;
  }
  @media only screen and (max-width: 990px) {
    width: 100%;
    padding-left: 10px;
  }
`;

export const ButtonWrapperError = styled.div`
    margin-top: 40px; 
    display: flex;
    flex-direction: column;
`;

export const ErrorMsgContainer = styled.div`
    width: 100%;
    margin-bottom: 10px; 
    display: flex;
    justify-content : flex-end;
`;

export const ButtonWrapperNew = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;

  @media only screen and (max-width: 990px) {
    flex-direction: column;
    flex-direction: column-reverse;
    margin-top: 40px;
    & > button {
      margin-top: 15px
  }
  }
`;


export const ButtonWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;

  @media only screen and (max-width: 990px) {
    flex-direction: column;
    flex-direction: column-reverse;
    margin-top: 40px;
    & > button {
        margin-top: 15px
    }
  }
`;

export const NextButtonWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: ${props => props.messageShown ? "space-between" : "flex-end"};

  @media only screen and (max-width: 576px) {
    display: block;
    margin-top: 40px;
  }
`;

export const GhostButtonComponentTiff = styled(GhostButtonComponent)`
  margin-left: 20px;
  @media only screen and (max-width: 990px) {
    margin: 0 0 15px 15px;
  }
`;

export const FooterWrapper = styled.div`
  width: 100%;
  content: "";
  clear: both;
  display: table;
`;

export const DollarAmount = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  text-align: right;
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.headingColor};
  @media (max-width: 576px) {
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

/** View and Edit Styles **/
export const SectionHeading = styled.h4`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: ${props => props.theme.lineHeight.h4};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-weight: ${props => props.theme.fontWeight.w500};
  margin-bottom: 30px;
  @media (max-width: 576px) {
    margin-bottom: 20px;
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
`;

export const HLine = styled.div`
  border-top: 2px solid ${props => props.theme.border.pill};
  margin: 50px 0px;
  @media (max-width: 576px) {
    margin: 40px 0px;
  }
`;

export const HLineMob = styled.div`
  display: none
  @media (max-width: 576px) {
    margin: 40px 0px;
    border-top: 2px solid ${props => props.theme.border.pill};
    display: block;
  }
`;

export const VLine = styled.div`
  border-right: 2px solid ${props => props.theme.border.inputBox};
  margin: 5px 10px;
  height: 15px;
  @media (max-width: 990px) {
    margin: 1px 10px;
  }
  @media (max-width: 576px) {
    display: none;
  }
`;

export const Heading = styled(DataValue)`
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.headingColor};
  @media(max-width: 576px){
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const SpaceBetween = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 576px) {
    justify-content: space-between;
  }
`;

export const DFlex = styled.div`
  display: flex;
  @media only screen and (max-width: 576px) {
    display: block;
  }
`;

export const DItems = styled.div`
  @media only screen and (max-width: 576px) {
    width: 50%;
  }
`;

export const DFlexWrap = styled.div`
  display: flex;
  width: 370px;
  justify-content: space-between;
  @media only screen and (max-width: 576px) {
    flex-wrap: wrap;
    width: initial;
    justify-content: initial;
    & ${DItems}:last-child {
      border: none;
    }
  }
`;



export const FormSubmitButton = styled.div`
  float: right;
  width: 150px;
  margin-bottom: 50px;
  @media (max-width: 990px) {
    width: 100%;
    margin-bottom: 0px;
  }
`;

export const GhostButtonDiv = styled(GhostButtonComponent)`
  width: 20% !important;
  @media (max-width: 990px) {
    width: 33% !important;
  }
  @media (max-width: 576px) {
    width: 100% !important;
    margin: 20px 0 0 0;
  }
`;

export const PrimaryButtonDiv = styled(PrimaryButtonComponent)`
  width: 20% !important;
  margin: 0 0 0 20px; 
  @media (max-width: 990px) {
    width: 33% !important;
  }
  @media (max-width: 576px) {
    width: 100% !important;
    margin: 20px 0 0 0;
  }
`;

export const DesktopView = styled.div`
  display: block;
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;

export const MobileView = styled.div`
  display: none;
  @media only screen and (max-width: 576px) {
    display: block;
  }
`;

export const Column = styled.div`
  display: block;
  margin-right: 100px;
`;
export const Row = styled.div`
  display: flex;
`;

export const PillAnchor = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 71px;
  height: 23px;
  margin-left: 15px;
  margin-top: 5px;
  background-color: ${props => props.theme.backgroundColor.pill};
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 1rem;
  p {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    letter-spacing: normal;
    line-height: 1.63;
    padding: 4px 0 0 4px;
    margin: 0;
  }
  @media only screen and (max-width: 1100px) {
    margin-top: 0px;
  }
  @media only screen and (max-width: 991.92px) {
    margin-top: 4px;
  }
  @media only screen and (max-width: 576px){
    margin-left: 10px;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const DesktopFlex = styled.div`
  display: flex;
  @media only screen and (max-width: 991.92px) {
    display: block;
  }
`;

export const DesktopTabFlex = styled.div`
  display: flex;
  @media only screen and (max-width: 576px) {
    display: block;
  }
`;

export const BoldLabel = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.headingColor};
  margin-top: 30px;
  @media only screen and (max-width: 576px) {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid ${props => props.theme.border.pill};
    text-align: center;
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const PoolName = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.tableFont};
  line-height: ${props => props.theme.lineHeight.tableFont};
  cursor: pointer;
  text-decoration: underline;
  color: ${props => props.theme.fontColors.primary};
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const PoolDataValue = styled(DataValue)`
  font-size: ${props => props.theme.fontSize.tableFont};
  line-height: ${props => props.theme.lineHeight.tableFont};
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const PoolDataHeading = styled(DataHeading)`
  font-size: ${props => props.theme.fontSize.tableFont};
  line-height: ${props => props.theme.lineHeight.tableFont};
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const PoolNameReview = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const FooterText = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  @media (max-width: 576px) {
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary};
    margin-top: 5px;
  }
`;

export const InlineBox = styled(DataValue)`
  display: inline;
  margin: 0 0 0 6px;
  @media only screen and (max-width: 576px) {
    display: block;
    margin: 5px 0 0 0;
  }
`;

// Alert Box
export const AlertPopUp = styled(Modal)`
  @media (max-width: 767px) {
    .ant-modal {
      max-width: calc(100vw - 44px) !important;
      margin: 0 22px !important;
    }
  }
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
    font-size: ${props => props.theme.fontSize.h4};
    color: ${props => props.theme.fontColors.textColor};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    text-align: center;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
  }
  .ant-modal-content {
    border-radius: 0px;
  }
  .ant-modal-header {
    padding: 30px 0 13px 0;
    border: none;
    border-radius: 0;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0 15px 0;
    }
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.textColor};
    padding: 24px 48px 30px 33px;
    text-align: center;
    @media only screen and (max-width: 991.92px) {
      max-height: 377px;
      overflow: scroll;
      border-top: 2px solid ${props => props.theme.border.filledTabsInactive};
      border-bottom: 2px solid ${props => props.theme.border.filledTabsInactive};
      padding: 19px 0px 0px 0px;
      margin: 0 27px 0 29px;
      &:after {
        background: linear-gradient(
            center bottom,
            #fff 0%,
            rgba(255, 255, 255, 0) 60%
          )
          repeat scroll 0 0 rgba(0, 0, 0, 0);
        bottom: 0;
        content: "";
        display: block;
        height: 30px;
        left: 0;
        pointer-events: none;
        position: fixed;
        width: 100%;
      }
    }
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
    padding: 0px 0px 30px 0px;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0px 30px 0px;
    }
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    display: none;
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: ${props => props.theme.fontColors.white};
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: 18px;
    font-weight: 900;
    font-stretch: condensed;
    line-height: 1.67;
    width: 200px;
    height: 50px;
    color: ${props => props.theme.fontColors.color};
    border: 1px solid ${props => props.theme.fontColors.color};
    &:hover {
      border: 1px solid ${props => props.theme.fontColors.color};
    }
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: ${props => props.theme.fontColors.color};
  }
`;

export const MessageAlert = styled(Modal)`
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-size: ${props => props.theme.fontSize.h4};
    color: ${props => props.theme.fontColors.headingColor};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    text-align: center;
    @media (max-width: 576px) {
      font-size: ${props => props.theme.fontSize.h5};
    }
  }
  .ant-modal-header {
    padding-top: 20px;
    border: none;
    border-radius: 0;
  }
  .ant-modal-content {
    border-radius: 0px;
  }
  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.textColor};
    text-align: center;
    padding: 0 24px 30px;
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
    padding: 0 16px 30px;
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    width: 150px;
    border-radius: 0;
    height: 50px;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    letter-spacing: 0.5px;
    color: ${props => props.theme.fontColors.white};
    background-color: ${props => props.theme.backgroundColor.primaryColor};
    @media (max-width: 576px) {
      line-height: ${props => props.theme.lineHeight.secondary};
      font-size: ${props => props.theme.fontSize.secondary};
      padding: 10px 0;
    }
  }
  .ant-modal-footer > div > .ant-btn-primary > span {
    color: ${props => props.theme.fontColors.white}!;
  }
  .ant-modal-footer > div > .ant-btn:first-child {
    display: none;
  }
`;

export const AlertPopUpPrimary = styled(Modal)`
  @media (max-width: 767px) {
    .ant-modal {
      max-width: calc(100vw - 44px) !important;
      margin: 0 22px !important;
    }
  }

  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
    font-size: ${props => props.theme.fontSize.h4};
    color: ${props => props.theme.fontColors.textColor};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    text-align: center;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
  }
  .ant-modal-content {
    border-radius: 0px;
  }
  .ant-modal-header {
    padding: 30px 0 13px 0;
    border: none;
    border-radius: 0;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0 15px 0;
    }
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.textColor};
    padding: 24px 48px 30px 33px;
    text-align: center;
    @media only screen and (max-width: 991.92px) {
      max-height: 377px;
      overflow: scroll;
      border-top: 2px solid ${props => props.theme.border.filledTabsInactive};
      border-bottom: 2px solid ${props => props.theme.border.filledTabsInactive};
      padding: 19px 0px 0px 0px;
      margin: 0 27px 0 29px;
      &:after {
        background: linear-gradient(
            center bottom,
            #fff 0%,
            rgba(255, 255, 255, 0) 60%
          )
          repeat scroll 0 0 rgba(0, 0, 0, 0);
        bottom: 0;
        content: "";
        display: block;
        height: 30px;
        left: 0;
        pointer-events: none;
        position: fixed;
        width: 100%;
      }
    }
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
    padding: 0px 0px 30px 0px;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0px 30px 0px;
    }
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    display: none;
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: ${props => props.theme.fontColors.white};
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    background-color: ${props => props.theme.backgroundColor.primaryColor};
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: 18px;
    font-weight: 900;
    font-stretch: condensed;
    line-height: 1.67;
    width: 200px;
    height: 50px;
    color: ${props => props.theme.fontColors.white};
    border: 1px solid ${props => props.theme.fontColors.color};
    &:hover {
      border: 1px solid ${props => props.theme.fontColors.color};
    }
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: ${props => props.theme.fontColors.color};
  }
`;

export const DescriptionTo = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.thead};
  margin: 15px 0 50px 0;
  line-height: ${props => props.theme.lineHeight.primary};
  @media (max-width: 576px) {
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary};
    margin: 5px 0 40px 0;
  }
`;

export const AmountInfo = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: 15px;
  @media (max-width: 576px) {
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary};
    margin-bottom: 5px;
  }
`;

export const TotalDollarAmount = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: 50px;
  @media (max-width: 576px) {
    margin-bottom: 40px;
  }
`;

export const TwoButtonModal = styled(Modal)`
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-size: ${props => props.theme.fontSize.h4};
    color: ${props => props.theme.fontColors.headingColor};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    text-align: center;
    @media (max-width: 576px) {
      font-size: ${props => props.theme.fontSize.h5};
    }
  }
  .ant-modal-header {
    padding-top: 30px;
    border: none;
    border-radius: 0;
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.textColor};
    text-align: center;
    padding: 15px 20px 30px 20px;
  }

  .ant-modal-footer {
    padding: 0px 16px 30px 16px;
    border-radius: 0;
    border: none;
    @media(max-width: 576px){
      padding: 0px 20px 30px 20px;
    }
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    width: 150px;
    border-radius: 0;
    height: 50px;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
    color: ${props => props.theme.fontColors.white};
    letter-spacing: 0.5px;
    margin-bottom: 10px;
    margin-left: 0px;
    background-color: ${props => props.theme.backgroundColor.primaryColor};
    @media only screen and (max-width: 576px) {
      width: 100%;
      line-height: ${props => props.theme.lineHeight.secondary};
      font-size: ${props => props.theme.fontSize.secondary};
      padding: 10px 0;
      letter-spacing: 1.13px;
    }
  }

  .ant-modal-footer button + button {
    @media only screen and (min-width: 320px) and (max-width: 347px) {
      margin-left: 0;
    }
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: ${props => props.theme.fontColors.white} !important;
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
    color: ${props => props.theme.fontColors.primary};
    border: 0px solid transparent;
    text-decoration: underline;
    box-shadow: none;
    &:focus {
      box-shadow: 0 0 0 0.15rem ${props => props.theme.fontColors.primary};
    }
    @media only screen and (max-width: 576px) {
      line-height: ${props => props.theme.lineHeight.secondary};
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: ${props => props.theme.fontColors.primary};
    text-decoration: underline;
  }

  .ant-modal-footer > div > .ant-btn-primary:focus {
    box-shadow: 0 0 0 0.15rem ${props => props.theme.fontColors.primary};
  }
`;

export const AlertContent = styled.div`
  > p {
    font-size: 16px;
    line-height: ${props => props.theme.lineHeight.primary};
    letter-spacing: 0;
    color: ${props => props.theme.fontColors.textColor};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    margin: 0px;
    @media(max-width: 576px){
      font-size: ${props => props.theme.fontSize.secondary};
      line-height: ${props => props.theme.lineHeight.secondary};
    }
  }
  > p:last-child {
    padding-top: 25px;
    @media(max-width: 576px){
      padding-top: 15px;
    }
  }
`;

export const AlertContentDiv = styled.div`
  > p {
    font-size: 16px;
    line-height: ${props => props.theme.lineHeight.primary};
    letter-spacing: 0;
    color: ${props => props.theme.fontColors.textColor};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    margin: 0px;
    @media(max-width: 576px){
      font-size: ${props => props.theme.fontSize.secondary};
      line-height: ${props => props.theme.lineHeight.secondary};
    }
  }
  > p:last-child {
    padding-top: 25px;
    @media(max-width: 576px){
      padding-top: 15px;
    }
  }
`;

export const ResetAll = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero} !important;
  font-size: ${props => props.theme.fontSize.primary};
  text-decoration: underline;
  flex-grow: 0 !important;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 0.6px;
  cursor: pointer;
  margin-right: 14.5%;
  @media (max-width: 990px) {
    margin-right: 10.8%;
  }
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const BorderBottom = styled.div`
  height: 2px;
  border-bottom: 1px solid ${props => props.theme.border.filledTabsInactive};
  margin: 50px 0;
  @media (max-width: 576px) {
    margin: 40px 0;
  }
`;

export const PoolCategory = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  font-size: 20px;
  line-height: 1.5;
  margin: 20px 0;
  text-transform: capitalize;
`;


export const FormHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  color: ${props => props.theme.fontColors.headingColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-size: 20px;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.5px;
  margin: 40px 0 20px 0;
`;

export const SubmitHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
  color: ${props => props.theme.fontColors.green};
  font-size: 24px;
  line-height: 1.5;
  letter-spacing: 0.5px;
  margin: 30px 0;
  @media (max-width: 576px) {
    margin: 20px 0;
    font-size: 20px;
  }
`;

export const PrintButton = styled.div` 
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  text-decoration: underline;
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  color: ${props => props.theme.fontColors.primary};
  margin-left: 10px;
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const PrintDiv = styled.div`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  @media (max-width: 576px) {
    margin: 10px 0 0 0;
  }
`;

export const PrintSection = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 576px) {
    display: block;
  }
`;

export const ClearFixDiv = styled.div`
  content: "";
  clear: both;
  display: table;
  border-top: solid 1px ${props => props.theme.border.pill};
  border-bottom: solid 1px ${props => props.theme.border.pill};
  width: 100%;
  padding: 10px 0;
`;


export const EditFlowTable = styled(CommonTable)`
  .ant-table {
    .ant-table-thead {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
      & > tr > th {
        color: ${props => props.theme.fontColors.thead};
        background-color: ${props => props.theme.backgroundColor.layoutLight};
        border-top: solid 1px ${props => props.theme.border.tableBorder} !important;
        border-radius: 0px;
        padding: 20px 10px 16px 16px;
      }
    }
    & .ant-table-tbody > tr > td {
      border-bottom: solid 1px ${props => props.theme.border.tableBorder} !important;
      border-radius: 0px;
      padding: 10px 16px;
    }
    .ant-table-row:nth-child(2n+1) {
      background-color: ${props => props.theme.backgroundColor.tableAltRowDark}!important;
    }
  }
`;


export const SelectBox = styled(Select)`
  .ant-select-selection{
    border-radius : 0px;
  }

  .ant-select-selection--multiple .ant-select-selection__rendered {
    height:40px;
    margin-bottom:-4px;
  }

  .ant-select-arrow{
    top: 0;
      padding: 16px 13px;
      background-color: ${props => props.theme.backgroundColor.pill};
      margin: 1px 1px;
      right: 0;
      bottom: 0;
  }

  .ant-select-selection__rendered {
    height:40px
  }
  .ant-select-search__field{
    margin-top: -4px;
    height: 40px;
  }

  .ant-select-selection--single{
    height: 40px;
  }

  .ant-select-selection__clear{
    top:50%;
    margin-right : 30px;
  }

  .ant-select-selection__rendered >ul > li.ant-select-selection__choice {
    margin-top:8px;
    border-radius:0px;
  }

  .ant-select-selection--single .ant-select-selection-selected-value{
    margin-top :4px;
    @media (min-width: 320px) and (max-width: 768px){
      color: ${props => props.theme.fontColors.textColor};
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      font-size: ${props => props.theme.fontSize.secondary};
     }
  }
`;


export const DTxnId = styled(DFlex)`
  @media(min-width : 767px){
    margin-top: 15px;
  }
`;

export const BalanceMessage = styled.div.attrs(()=>({
  className: "error-fields"
  }))`  
  margin-top: 30px;
  color: ${props => props.theme.fontColors.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  word-break: ${props => props.isWordBreak ? 'break-word' : 'normal'};
  @media only screen and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media(max-width : 567px){
    margin-top: 20px;
  }
`;

export const LinkNavigatorPW = styled.a`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  word-break: break-all;
  display: inline-block;
  &.disable-hyperlink {
    color: rgba(80, 80, 80, 0.5)!important;
    pointer-events: none;
  }
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;

export const UnderlyingContent = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  line-height: ${props => props.theme.lineHeight.tableFont};
  font-size: ${props => props.theme.fontSize.tableFont}
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  :hover{
    text-decoration: underline;
  }
  @media only screen and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;